import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MongoService } from 'src/app/api/mongo.service';
import { variableGlobal } from 'src/app/global.enum';
import { CrearEditarMetaComponent } from './crear-editar-meta/crear-editar-meta.component';
import Swal from 'sweetalert2';
import { IntranetoldService } from 'src/app/api/intranetold.service';


@Component({
  selector: 'app-metas-crud',
  templateUrl: './metas-crud.component.html',
  styleUrls: ['./metas-crud.component.css']
})
export class MetasCRUDComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private _apiMongo: MongoService,
    private _api:IntranetoldService,
    ) { }

  jsonMetas:any;
  mes:any;
  anio:any;
  metas:any;
  allmetas:any;
  allmetasView:any;
  usuarios:any;
  FiltroMes:any;
  FiltroAnio:any;
  cargando:any;

  async CargaInicial(){

    this.allmetas = await this._apiMongo.getAllMetas();
    this.allmetasView = this.allmetas.reverse();
    

  }
  ngOnInit() {

    this.CargaInicial();

  }

  async crearMeta() {

    let body = {
      SlpCode:"",
      CONCEPTO:"",
      NOMBRE:"",
      MES:"",
      ANIO:"",
      VALOR:""
    }

    let ngbModalOptions: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG,
    };

    const modalRef = this.modalService.open(CrearEditarMetaComponent, ngbModalOptions);
    modalRef.componentInstance.data = body;
    modalRef.componentInstance.modalReference = modalRef;

  }

  async editarMeta(row) {
    

    let body = {
      _id:row._id,
      SlpCode:row.SlpCode,
      CONCEPTO:row.CONCEPTO,
      NOMBRE:row.NOMBRE,
      MES:row.MES,
      ANIO:row.ANIO,
      VALOR:row.VALOR
    }

    let ngbModalOptions: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG,
    };

    const modalRef = this.modalService.open(CrearEditarMetaComponent, ngbModalOptions);
    modalRef.componentInstance.data = row;
    modalRef.componentInstance.modalReference = modalRef;

  }

  async eliminarMeta(row){

    Swal.fire({
      title: '¿Estás seguro?',
      text: "Esta acción no se puede deshacer.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Confirmar',
      reverseButtons: true
  }).then(async (result) => {
      if (result.isConfirmed) {
        let res:any = await this._apiMongo.eliminarMeta(row);
        
        if (res.estado) {
          Swal.fire({
            title: '¡Éxito!',
            text: 'La meta se eliminó con éxito.',
            icon: 'success',
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false
          });
          this.cargando = true;
          await this.CargaInicial();
          await this.limpiar();
          this.cargando = false;
        }
        else
        {
          Swal.fire({
            title: '¡Error!',
            text: res.mensaje,
            icon: 'error',
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false
          });
          
        }
      }
  })

  }

  filtrar(){
    if (this.FiltroAnio && this.FiltroMes) {
      this.allmetasView = this.allmetas.filter(objeto =>
        objeto.MES == this.FiltroMes && objeto.ANIO == this.FiltroAnio
      );
    }
    else if (this.FiltroMes) {
      this.allmetasView = this.allmetas.filter(objeto =>
        objeto.MES == this.FiltroMes
      );
    }
    else if (this.FiltroAnio) {
      this.allmetasView = this.allmetas.filter(objeto =>
        objeto.ANIO == this.FiltroAnio
      );
    }
    else
    {
      this.allmetasView = this.allmetas;
    }
  
  }

  limpiar(){
    this.FiltroAnio = null;
    this.FiltroMes = null;
    this.filtrar();
  }

  async copiar(row) {

    let body = {
      _id:null,
      SlpCode:row.SlpCode,
      CONCEPTO:row.CONCEPTO,
      NOMBRE:row.NOMBRE,
      MES:row.MES,
      ANIO:row.ANIO,
      VALOR:row.VALOR
    }

    let ngbModalOptions: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG,
    };

    const modalRef = this.modalService.open(CrearEditarMetaComponent, ngbModalOptions);
    modalRef.componentInstance.data = body;
    modalRef.componentInstance.modalReference = modalRef;

  }

}
